import { RestClient } from '@/api/rest-client'
import { UserTarget } from '@/api/model/user-target'
import { Pipeline } from '@/api/model/pipeline'
import { cloneDeep } from 'lodash'

export class UserTargetClient extends RestClient<UserTarget> {
    collectionName = 'user_targets'
    parseData = UserTarget.fromData

    async create(data: UserTarget): Promise<UserTarget> {
        const request = cloneDeep<any>(data)

        if (data.referralPipeline instanceof Pipeline) {
            request.referralPipeline = data.referralPipeline.resourceIdentifier
        }

        return super.create(request)
    }

    async update(id: string, data: UserTarget): Promise<UserTarget> {
        const request = cloneDeep<any>(data)

        if (data.referralPipeline instanceof Pipeline) {
            request.referralPipeline = data.referralPipeline.resourceIdentifier
        }

        return super.update(id, request)
    }
}
